module.exports = __webpack_public_path__ + "img/AT0000002401501.edbfd53e.png";